import * as AppConstants from '../constants/app';

export type CustomerAlertBoxState = typeof initialState.customerAlertBox;

export const initialState = {
  activeAccountInfo: {},
  user: undefined,
  imUser: undefined,
  permissions: [],
  features: [],
  cadenceAccounts: [],
  customerAlertBox: { visible: false, title: '', description: '' },
  marketingContent: {
    productTeasers: {},
  },
  clientIp: undefined,
  loadingAccounts: false,
  loginDetails: {
    email: '',
  },
  deviceId: undefined,
  isSideNavigationCollapsed: false,
};

export default function appReducer(newState = initialState, action) {
  switch (action.type) {
    case AppConstants.SET_ACTIVE_ACCOUNT_INFO: {
      return {
        ...newState,
        activeAccountInfo: action.activeAccountInfo,
      };
    }
    case AppConstants.SET_USER:
      return {
        ...newState,
        user: action.user ? { ...action.user } : undefined,
        permissions: action.user && action.user.permissions?.filter((p) => p.status === 'active').map((p) => p.name),
      };
    case AppConstants.SET_LOGIN_DETAILS:
      return {
        ...newState,
        loginDetails: action.details,
      };
    case AppConstants.SET_FEATURES:
      return {
        ...newState,
        features: action.features,
      };
    case AppConstants.SET_IM_USER: {
      return {
        ...newState,
        imUser: action.user,
      };
    }
    case AppConstants.SET_CADENCE_ACCOUNTS: {
      return { ...newState, cadenceAccounts: action.cadenceAccounts };
    }
    case AppConstants.SET_CUSTOMER_ALERT_BOX: {
      return { ...newState, customerAlertBox: action.customerAlertBox };
    }
    case AppConstants.SET_LOADING_ACCOUNTS: {
      return { ...newState, loadingAccounts: action.loadingAccounts };
    }
    case AppConstants.SET_PRODUCT_TEASER: {
      return {
        ...newState,
        marketingContent: {
          ...newState.marketingContent,
          productTeasers: {
            ...newState.marketingContent.productTeasers,
            [action.productTeaser.product]: action.productTeaser.web,
          },
        },
      };
    }
    case AppConstants.SET_CLIENT_IP: {
      return { ...newState, clientIp: action.clientIp };
    }
    case AppConstants.SET_DEVICE_ID: {
      return { ...newState, deviceId: action.deviceId };
    }
    case AppConstants.SET_IS_SIDE_NAVIGATION_COLLAPSED: {
      return { ...newState, isSideNavigationCollapsed: action.isSideNavigationCollapsed };
    }
    default:
      return newState;
  }
}
